import axios from 'axios'
import { config, url } from '@/store'
import moment from 'moment'

const state = () => ({
  dateFrom: '',
  dateTo: '',
  weekDays: [
    'Пн',
    'Вт',
    'Ср',
    'Чт',
    'Пт',
    'Сб',
    'Вс'
  ],
  monthNames: [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь'
  ],
  _vars: {
    nowDate: null,
    nowDateNumber: null,
    nowMonth: null,
    nowYear: null
  },
  monthCalendar: {
    year: null,
    month: null,
    monthName: null,
    days: []
  },
  activityModal: {
    active: false,
    activity: null
  },
  eventModal: {
    active: false,
    attachment: {
      linkTooltip: {
        active: false,
        text: '',
        url: '',
        textValid: {},
        urlValid: {}
      },
      tagTooltip: {
        active: false,
        text: '',
        valid: {}
      },
      files: [],
      tags: [],
      filesToRemove: []
    }
  }
})

const getters = {
  getUserCalendarWeekDays: state => state.weekDays,
  getUserCalendarMonthCalendar: state => state.monthCalendar,
  getUserCalendarActivityModal: state => state.activityModal,
  getUserCalendarEventModal: state => state.eventModal,
  getmonthNames: state => state.monthNames
}

const mutations = {
  '[user-calendar] OPEN_EVENT_MODAL': state => {
    state.eventModal.active = true
  },
  '[user-calendar] CLOSE_EVENT_MODAL': state => {
    state.eventModal.active = false
  },
  '[user-calendar] SET_VARIABLES': state => {
    state._vars.nowDate = new Date()
    state._vars.nowDateNumber = state._vars.nowDate.getDate()
    state._vars.nowMonth = state._vars.nowDate.getMonth()
    state._vars.nowYear = state._vars.nowDate.getFullYear()
  },
  '[user-calendar SET_DAYS]': (state, days) => {
    state.monthCalendar.days = days
  },
  '[user-calendar] SET_INITIAL_ACTIVITIES': (state) => {
    state.monthCalendar.days.forEach(e => {
      if (e.activities && e.activities.length) {
        e.activities = []
      }
    })
  },
  '[user-calendar] SET_DAY_ACTIVITIES': (state, activities) => {
    const year = state.monthCalendar.year
    const month = state.monthCalendar.month + 1 < 10 ? `0${state.monthCalendar.month + 1}` : state.monthCalendar.month + 1
    const daysArray = state.monthCalendar.days
    const repeatActivities = []

    activities.forEach(activity => {
      const activityStartAt = activity.itemable?.start_at?.slice(0, 10)
      const targetDay = daysArray.find(day => {
        const dayNumber = day.number < 10 ? `0${day.number}` : day.number
        return `${year}-${month}-${dayNumber}` === activityStartAt
      })

      if (targetDay) {
        targetDay.activities.push({
          id: activity.itemable.id,
          name: activity.itemable.name,
          color: '#EA803A',
          start_at: activity.itemable.start_at,
          itemable: activity.itemable
        })
      }

      if (activity.itemable?.activity_repeat[0]) {
        const repeatDate = activity.itemable.activity_repeat[0].next_at
        const itemable = activity.itemable
        console.log('repeatDate', repeatDate)
        console.log('itemable', itemable)
        itemable.start_at = repeatDate
        itemable.end_at = repeatDate

        repeatActivities.push({
          itemable: itemable
        })
      }

      if (targetDay) {
        targetDay.activities.sort(function (a, b) {
          if (a.start_at > b.start_at) {
            return 1
          }
          if (a.start_at < b.start_at) {
            return -1
          }
          return 0
        })
      }
    })
    repeatActivities.forEach(activity => {
      const activityStartAt = activity.itemable?.start_at?.slice(0, 10)
      const targetDay = daysArray.find(day => {
        const dayNumber = day.number < 10 ? `0${day.number}` : day.number
        return `${year}-${month}-${dayNumber}` === activityStartAt
      })
      const repeatId = activity.itemable.id
      const itemable = activity.itemable
      console.log('activity.itemable.id', repeatId)
      if (targetDay) {
        targetDay.activities.push({
          id: repeatId,
          name: activity.itemable.name,
          color: '#EA803A',
          start_at: activity.itemable.start_at,
          itemable: itemable
        })
      }
    })
  },
  '[user-calendar] SET_MONTH_CALENDAR_DATA': (state, calendarData) => {
    state.monthCalendar.year = calendarData.year
    state.monthCalendar.month = calendarData.month
    state.monthCalendar.monthName = calendarData.monthName
  },
  '[user-calendar] SET_DATE_FROM': (state, date) => {
    state.dateFrom = date
  },
  '[user-calendar] SET_DATE_TO': (state, date) => {
    state.dateTo = date
  },
  '[user-calendar] OPEN_ACTIVITY_MODAL': (state, activity) => {
    state.activityModal.active = true
    state.activityModal.activity = {
      ...activity,
      users: activity.users ? activity.users : [],
      departments: activity.departments ? activity.departments : [],
      groups: activity.groups ? activity.groups : []
    }
  },
  '[user-calendar] CLOSE_ACTIVITY_MODAL': (state) => {
    state.activityModal.active = false
    state.activityModal.activity = null
  }
}

const actions = {
  '[user-calendar] getActivities' ({ commit, state }) {
    const { year, month } = state.monthCalendar
    const dayCount = new Date(year, month + 1, 0).getDate()
    const startDate = moment(new Date(year, month)).format('DD-MM-YYYY')
    const endDate = moment(new Date(year, month, dayCount)).format('DD-MM-YYYY')

    const params = {
      sort: '-created_at',
      'search[type]': 'Activity',
      expand: 'itemable,owner',
      'search[from_date]': startDate,
      'search[to_date]': endDate,
      'per-page': 1000
    }

    axios.get(`${url}/event-posts`, { params, ...config }).then(response => {
      commit('[user-calendar] SET_DAY_ACTIVITIES', response.data.data)
    }).catch(error => {
      console.log('Ошибка получения мероприятий для календаря:', error)
    })
  },
  '[user-calendar] setFilters' ({ commit, state }, currentDays) {
    const days = currentDays.filter(day => {
      return day.number
    })
    const year = state.monthCalendar.year
    const month = state.monthCalendar.month
    const firstMonthDate = `${year}-${month + 1 < 10 ? `0${month + 1}` : month + 1}-${days[0].number < 10 ? `0${days[0].number}` : days[0].number}`
    const lastMonthDate = `${year}-${month + 1 < 10 ? `0${month + 1}` : month + 1}-${days[days.length - 1].number < 10 ? `0${days[days.length - 1].number}` : days[days.length - 1].number}`

    commit('[user-calendar] SET_DATE_FROM', firstMonthDate)
    commit('[user-calendar] SET_DATE_TO', lastMonthDate)
  },
  '[user-calendar] setVariables' ({ commit }) {
    return new Promise(resolve => {
      commit('[user-calendar] SET_VARIABLES')
      resolve('success')
    })
  },
  '[user-calendar] initCalendar' ({ dispatch, state }) {
    dispatch('[user-calendar] setVariables').then(() => {
      const params = {
        year: state._vars.nowYear,
        month: state._vars.nowMonth
      }

      dispatch('[user-calendar] setMonthCalendar', params)
    })
  },
  '[user-calendar] setMonthCalendar' ({ dispatch, commit, state }, params) {
    const monthDays = new Date(params.year, params.month + 1, 0).getDate()
    const monthPrefix = new Date(params.year, params.month, 0).getDay()
    const monthDaysArray = []

    const nowMonth = state._vars.nowMonth
    const nowYear = state._vars.nowYear
    const nowDateNumber = state._vars.nowDateNumber

    const calendarData = {
      year: params.year,
      month: params.month,
      monthName: state.monthNames[params.month]
    }
    commit('[user-calendar] SET_MONTH_CALENDAR_DATA', calendarData)

    if (monthPrefix > 0) {
      for (let i = 1; i <= monthPrefix; i++) {
        monthDaysArray.push({
          isEmpty: true
        })
      }
    }

    for (let i = 1; i <= monthDays; i++) {
      monthDaysArray.push({
        number: i,
        activities: [],
        isToday: false
      })
    }

    if (params.month === nowMonth && params.year === nowYear) {
      monthDaysArray[monthPrefix + nowDateNumber - 1].isToday = true
    }

    commit('[user-calendar SET_DAYS]', monthDaysArray)

    dispatch('[user-calendar] setFilters', monthDaysArray)
    dispatch('[user-calendar] getActivities')
  },
  '[user-calendar] setMonth' ({ dispatch, state }, direction) {
    const nowYear = state.monthCalendar.year
    const nowMonth = state.monthCalendar.month
    const currentDate = new Date(nowYear, nowMonth)

    if (direction === 'prev') {
      currentDate.setMonth(currentDate.getMonth() - 1)
    } else if (direction === 'next') {
      currentDate.setMonth(currentDate.getMonth() + 1)
    }

    const params = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth()
    }

    dispatch('[user-calendar] setMonthCalendar', params)
  },
  '[user-calendar] openActivityModal' ({ commit }, { id, ownerId }) {
    axios.get(`${url}/activities/${id}?expand=files,users,groups,departments,`, config).then(response => {
      commit('[user-calendar] OPEN_ACTIVITY_MODAL', { ...response.data.data, ownerId })
    }).catch(error => {
      console.log('ошибка получения мероприятия из календаря', error)
    })
  },
  '[user-calendar] editFeedEventModalCalendar' ({ state, commit }, id) {
    console.log(state, id)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
